/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanApiResponse } from '../../models/boolean-api-response';
import { CheckAccessCommand } from '../../models/check-access-command';

export interface CheckAdminOrMasterAccessAsync$Plain$Params {
  command?: CheckAccessCommand;
}

export function checkAdminOrMasterAccessAsync$Plain(http: HttpClient, rootUrl: string, params?: CheckAdminOrMasterAccessAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanApiResponse>> {
  const rb = new RequestBuilder(rootUrl, checkAdminOrMasterAccessAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('command', params.command, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanApiResponse>;
    })
  );
}

checkAdminOrMasterAccessAsync$Plain.PATH = '/api/access/admin-master';
